import styles from './index.less';
import { SearchBar, SearchBarRef, Button, Space } from 'antd-mobile';
import { useRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';

const Search = () => {
  const searchRef = useRef<SearchBarRef>(null);

  const search = (value: string) => {
    console.log(value, 'search value');
  };

  const jumpToRepairContent = () => {
    history.push('/repairContent');
  };

  return (
    <div className={styles['search-container']}>
      <SearchBar
        className={styles['search-input']}
        ref={searchRef}
        placeholder={'请输入标题模糊查询'}
        onSearch={search}
      />
      <Button onClick={jumpToRepairContent} className={styles['search-btn']}>
        <Space>
          <PlusOutlined />
          <span>新建</span>
        </Space>
      </Button>
    </div>
  );
};

export default Search;
